const initState = {
    apiURL: process.env.REACT_APP_API,
    token: '',
    online: true,
    debugHeap: false,
    appModus: 'User', // 'User', 'Admin'
    appPreview: false,
    currentContainer: '',
    currentContainerTitle: '',
    checkContainersInterval: 3600,
    path: '',
    iPhone: false,
    isSafari: false,
    hasTouchScreen: null,
    portfoliosReady: false,
    containersReady: false,
    gridEdit: false,
    gridEditType: false,
    coverEdit: false,
    fieldEdit: -1,
    orientation: 'landscape',
    dialogType: 'portfolios',
    toolbarType: 'portfolios',
    modalDialog: { dialog: null, type: null, details: null },
    groupPos: 0,
    pageIndex: 0,
    tagList: [],
    galleryGroup: 1,
    gallerySearch: false,
    galleryIndex: 0,
    galleryImages: [],
    galleryTimestamp: '',
    searchImagesOnly: false,
    productList: [],
    customLayout: [],
    filterVisible: false,
    filterIndex: 0,
    filterList: [],
    favoredIndex: 0,
    favoredList: [],
    searchIndex: 0,
    searchString: '',
    windowWidth: 0,
    windowHeight: 0,
    unitHeight: 0,
    headerHeight: 0,
    toolbarHeight: 0,
    inputHeight: 0,
    imageBuffer: {}
}

export default function reducer(state = initState, action) {

    switch (action.type) {

        case "RESIZE_MAIN": {
            //console.log('################# RESIZE_MAIN ####################', action.payload);

            // ==========================================================================
            // 
            // Detect Touchscreen
            // 
            // ==========================================================================
            let hasTouchScreen = false;

            if ("maxTouchPoints" in navigator) {
                hasTouchScreen = navigator.maxTouchPoints > 0;
            } else if ("msMaxTouchPoints" in navigator) {
                hasTouchScreen = navigator.msMaxTouchPoints > 0;
            } else {
                var mQ = window.matchMedia && matchMedia("(pointer:coarse)");
                if (mQ && mQ.media === "(pointer:coarse)") {
                    hasTouchScreen = !!mQ.matches;
                } else if ('orientation' in window) {
                    hasTouchScreen = true; // deprecated, but good fallback
                } else {
                    // Only as a last resort, fall back to user agent sniffing
                    var UA = navigator.userAgent;
                    hasTouchScreen = (
                        /\b(BlackBerry|webOS|iPhone|IEMobile)\b/i.test(UA) ||
                        /\b(Android|Windows Phone|iPad|iPod)\b/i.test(UA)
                    );
                }
            }

            // ==========================================================================
            // 
            // Detect CORDOVA
            // 
            // ==========================================================================
            if (window['cordova']) {
                //console.log('CORDOVA:', JSON.stringify(window.cordova));

                window.cordova.plugins.backgroundMode.enable();
            }

            // ==========================================================================
            // 
            // Detect Browser
            // 
            // Mit isSafari wird an mehreren Stellen auf Safari Besonderheiten eingegangen
            // Z.B.: werden Videos in der IndexedDB nicht als 'blob' sondern als 'arrayBuffer'
            // gespeichert. Im Gegensatz zum 'blob' wird beim 'arrayBuffer' ein Video erst
            // dann abgespielt, wenn es vollständig in den Speicher geladen wurde. Beim 'blob'
            // wird der Video gestreamt, d.h.: Das Video startet sofort und lädt dann nach.
            // Leider lassen sich Video unter Mobil-Safari nicht sicher abspielen. 
            // Auch beim Speichern der Videos in der IndexedDB muss der angeforderte Speicherpaltz 
            // bestätigt werden. aus diesem Grund ist die PWA-Version für Safari nicht freigegeben. 
            // ==========================================================================
            const isSafari = (navigator.userAgent.indexOf("Safari") !== -1) ? true : false;
            //console.log('isSafari:', isSafari);

            // ==========================================================================
            // Detect Smartphone like iPhone etc.
            // ==========================================================================
            let iPhone = navigator.platform.indexOf('iPhone') >= 0;
            //console.log('navigator.platform:', navigator.platform)
            //console.log('iPhone:', iPhone)

            // ==========================================================================
            // Detect WindowSize
            // ==========================================================================

            let windowWidth = window.innerWidth;
            let windowHeight = window.innerHeight;

            if (window['cordova']) {
                windowWidth = window.outerWidth;
                windowHeight = window.outerHeight;
            }

            // ==========================================================================
            // Detect Orientation
            // ==========================================================================
            const orientation = (windowWidth > windowHeight) ? 'landscape' : 'portrait';

            const unitHeight = orientation === 'landscape' ? windowHeight * .08 : windowHeight * .07;

            // ==========================================================================
            // Detect SafeArea
            // ==========================================================================
            const safeAreaTop = parseInt(getComputedStyle(document.documentElement).getPropertyValue("--sat"));
            //const safeAreaRight = parseInt( getComputedStyle(document.documentElement).getPropertyValue("--sar") );
            const safeAreaBottom = parseInt(getComputedStyle(document.documentElement).getPropertyValue("--sab"));
            //const safeAreaLeft = parseInt( getComputedStyle(document.documentElement).getPropertyValue("--sal") );

            //console.log('safeAreaTop:', safeAreaTop)
            //console.log('safeAreaRight:', safeAreaRight)
            //console.log('safeAreaBottom:', safeAreaBottom)
            //console.log('safeAreaLeft:', safeAreaLeft)    


            let headerHeight = parseInt(unitHeight + safeAreaTop);
            let toolbarHeight = parseInt(unitHeight + safeAreaBottom);

            if (orientation === 'landscape' && iPhone) {
                headerHeight = 0;
                toolbarHeight = 0;
            }

            const inputHeight = windowHeight - headerHeight - toolbarHeight;

            return {
                ...state,
                iPhone: iPhone,
                isSafari: isSafari,
                hasTouchScreen: hasTouchScreen,
                orientation: orientation,
                windowWidth: windowWidth,
                windowHeight: windowHeight,
                unitHeight: unitHeight,
                headerHeight: headerHeight,
                toolbarHeight: toolbarHeight,
                inputHeight: inputHeight
            }
        }
        case "RESET_APP": {
            return initState;
        }
        case "RESET_CONTAINER": {
            return {
                ...state, path: '',
                filterList: [], filterIndex: 0,
                favoredList: [], favoredIndex: 0,
                searchString: '', searchIndex: 0,
                customLayout: []
            }
        }
        case "SET_API_URL": {
            return { ...state, apiURL: action.payload }
        }
        case "SET_APP_MODUS": {
            return { ...state, appModus: action.payload }
        }
        case "SET_APP_PREVIEW": {
            return { ...state, appPreview: action.payload }
        }
        case "SET_ONLINE": {
            return { ...state, online: action.payload }
        }
        case "SET_DIALOG_TYPE": {
            return { ...state, dialogType: action.payload }
        }
        case "SET_MODAL_DIALOG": {
            return { ...state, modalDialog: action.payload }
        }
        case "SET_TOOLBAR_TYPE": {
            return { ...state, toolbarType: action.payload, gridEdit: false, filterVisible: false }
        }
        case "SET_PAGE_INDEX": {
            return { ...state, pageIndex: action.payload }
        }
        case "SET_FIELD_EDIT": {
            return { ...state, fieldEdit: action.payload.id }
        }
        case "SET_GRID_EDIT": {
            return { ...state, gridEdit: action.payload, gridEditType: false }
        }
        case "SET_GRID_EDIT_TYPE": {
            return { ...state, gridEditType: action.payload }
        }
        case "SET_COVER_EDIT": {
            return { ...state, coverEdit: action.payload }
        }
        case "SET_SYNC_JSON": {
            return { ...state, productList: action.payload.productList, tagList: action.payload.tagList }
        }
        case "SET_PRODUCT_LIST": {
            return { ...state, productList: action.payload }
        }
        case "SET_FILTER_VISIBLE": {
            return { ...state, filterVisible: action.payload }
        }
        case "SET_FILTER_INDEX": {
            return { ...state, filterIndex: action.payload }
        }
        case "SET_FILTER_LIST": {
            return { ...state, filterList: action.payload, searchString: '' }
        }
        case "SET_FAVORED_INDEX": {
            return { ...state, favoredIndex: action.payload.index, path: action.payload.path, toolbarType: 'portfolios' }
        }
        case "SET_FAVORED_LIST": {
            return { ...state, favoredList: action.payload }
        }
        case "SET_SEARCH_STRING": {
            return { ...state, searchString: action.payload }
        }
        case "SET_SEARCH_INDEX": {
            return { ...state, searchIndex: action.payload.index, path: action.payload.path, toolbarType: 'portfolios' }
        }
        case "SET_PATH": {
            return { ...state, path: action.payload }
        }
        case "SET_GROUP_POS": {
            return { ...state, groupPos: action.payload }
        }
        case "SET_GALLERY_INDEX": {
            return { ...state, galleryIndex: action.payload }
        }
        case "SET_GALLERY_TIMESTAMP": {
            return { ...state, galleryTimestamp: action.payload }
        }
        case "SET_GALLERY_IMAGES": {
            return { ...state, galleryImages: action.payload }
        }
        case "SET_SEARCH_IMAGES_ONLY": {
            return { ...state, searchImagesOnly: action.payload }
        }
        case "SET_GALLERY_SEARCH": {
            return { ...state, gallerySearch: action.payload }
        }
        case "SET_GALLERY_GROUP": {
            return { ...state, galleryGroup: action.payload }
        }
        case "SET_CUSTOM_LAYOUT": {
            return { ...state, customLayout: action.payload }
        }
        case "SET_TOKEN": {
            return { ...state, token: action.payload }
        }
        case "SET_PORTFOLIOS_READY": {
            return { ...state, portfoliosReady: action.payload }
        }
        case "SET_CONTAINERS_READY": {
            return { ...state, containersReady: action.payload }
        }
        case "SET_CURRENT_CONTAINER": {
            return { ...state, currentContainer: action.payload }
        }
        case "SET_CURRENT_CONTAINER_TITLE": {
            return { ...state, currentContainerTitle: action.payload }
        }
        case "SET_ALL_IMAGES": {
            return { ...state, imageBuffer: action.payload }
        }
        default: return state
    }
}